
export function toggleLoader (status) {
  if (status) {
    // document.getElementById("loader-error-msg").innerHTML = "";
    document.getElementById("loader").style.display = "block";
  } else {
    document.getElementById("loader").style.display = "none";
  }
};


export function hideFormErrors() {
  const errorElList = document.getElementsByClassName('dc-form-field-error');
  for (const errEl of errorElList) {
    errEl.classList.remove('dc-form-field-error');
  }

  const errorMsgList = document.getElementsByClassName('dc-input-validation-error-message');
  for (const errMsgEl of errorMsgList) {
    errMsgEl.innerHTML = '';
    errMsgEl.style.display = 'none';
  }

  const successMsgList = document.getElementsByClassName('dc-input-validation-success-message');
  for (const successMsgEl of successMsgList) {
    successMsgEl.innerHTML = '';
    successMsgEl.style.display = 'none';
  }

  const globalMsgEl = document.getElementById("form-error-message");
  if (globalMsgEl !== null) {
    globalMsgEl.innerHTML = '';
    globalMsgEl.style.display = 'none';
  }
}

export function showFormGlobalError(formEl, errorMsg) {
  const msgEl = document.getElementById("form-error-message");
  if (msgEl !== null) {
    msgEl.innerHTML = errorMsg;
    msgEl.style.display = 'block';
    formEl.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}

export function showFormErrors(formEl, errors) {

  hideFormErrors();

  let msg = '';
  let firstErrorEl = null;
  if (errors.constructor.name === 'Array') {
    for (const error of errors) {
      // console.log(error);
      for (const property in error) {
        if (property === '') {
          msg += (`<p>${error[property]}</p>`);
        }

        let propertyEl = document.getElementById(property);

        if (firstErrorEl == null) {
          firstErrorEl = propertyEl;
        }

        propertyEl.classList.add("dc-form-field-error");

        let err_div = document.getElementById(`${property}-error-div`);

        if (err_div === null) {
          propertyEl.insertAdjacentHTML('afterend', `<div id='${property}-error-div' class='dc-input-validation-error-message'>${error[property]}</div>`);
        } else {
          err_div.innerHTML = error[property];
          err_div.style.display = 'block';
        }
      }
    }
  } else {
    msg = errors;
  }

  // showFormGlobalError(formEl, 'Ocorreu um erro! Por favor, volte a tentar de novo.');
  if (msg != '') {
    showFormGlobalError(formEl, msg);
  } else {
    if (firstErrorEl !== null) {
      firstErrorEl.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
  }

}
